var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMercleLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 19,
    viewBox: "0 0 98 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_189_1648",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 98,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.219 0.5H0V18.5H97.219V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_189_1648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9766 0.5V8.08158H6.23633V0.5H10.9766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5278 4.06128V9.06872H0V4.06128H15.5278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70373 7.85303C12.7112 9.55136 15.5292 13.5234 15.5292 18.1429H10.5218C10.5218 15.7129 9.10724 13.6065 7.05859 12.6033",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.17 6.97217H6.16259C6.16259 10.37 3.3978 13.1348 0 13.1348V18.1423C6.15816 18.1423 11.1689 13.1325 11.1689 6.97327L11.17 6.97217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9533 12.0642L94.2177 9.37918C93.3397 7.30503 90.9219 6.3838 88.8677 7.05117C86.9055 7.6886 85.4377 9.847 85.9533 12.0642ZM97.1389 10.4379L86.543 13.8811C87.7758 15.7901 89.8964 16.5816 91.8587 15.9442C93.3586 15.4564 94.5159 14.227 94.8197 12.6473L97.2209 11.8669C97.069 14.7779 95.2143 17.238 92.4673 18.1303C88.8666 19.2999 84.94 17.1126 83.8481 13.7525C82.5577 9.77938 84.7039 6.01909 88.0972 4.91715C91.8598 3.69439 95.6523 5.62554 96.824 9.23507C96.9493 9.62085 97.0679 9.98446 97.1389 10.4379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9626 18.1652H79.4805V0.5H81.9626V18.1652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4872 13.7972H78.2564C77.2055 16.7815 74.6757 18.4998 71.739 18.4998C67.9433 18.4998 64.959 15.4445 64.959 11.672C64.959 7.68556 67.848 4.58154 71.7147 4.58154C74.7223 4.58154 77.4682 6.46723 78.2564 9.33181H75.5116C74.771 7.77979 73.577 6.84859 71.7867 6.84859C69.1849 6.84859 67.4422 8.82962 67.4422 11.5279C67.4422 14.2261 69.2325 16.2305 71.739 16.2305C73.4341 16.2305 74.7943 15.3237 75.4872 13.796V13.7972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.993 18.1661H58.5098V4.94072H60.8256V6.04598C60.8256 6.06482 60.84 6.07923 60.8589 6.07923C60.8677 6.07923 60.8765 6.0759 60.8832 6.06815C61.9762 4.90968 63.4063 4.58154 65.1801 4.58154V7.13571C62.7911 7.13571 60.9919 7.50375 60.9919 10.7408V18.165L60.993 18.1661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1285 12.0784L54.2567 9.43777C53.382 7.3625 50.9952 6.43129 48.9754 7.08757C47.0454 7.71503 45.6087 9.86235 46.1285 12.0784ZM57.14 10.5087L46.7194 13.8943C47.9433 15.8054 50.0352 16.607 51.9653 15.9795C53.4407 15.4994 54.5748 14.2778 54.8664 12.7026L57.2277 11.9354C57.0925 14.841 55.2766 17.2876 52.5749 18.1656C49.0331 19.3163 45.1542 17.1125 44.0633 13.7523C42.7718 9.77921 44.8692 6.03553 48.2072 4.95135C51.9076 3.74854 55.6523 5.6952 56.8253 9.30474C56.9505 9.69052 57.0692 10.0541 57.1412 10.5075L57.14 10.5087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3391 18.1895H20.7871L25.0196 6.99504C25.5473 5.45855 26.4198 4.50406 28.2434 4.50406C30.271 4.50406 31.2831 5.68026 31.2831 7.43071V15.3792C31.2831 15.8371 31.568 16.1342 31.9704 16.1342C32.3362 16.1342 32.6201 15.9157 32.7387 15.5754L36.0621 6.99171C36.5899 5.45965 37.4579 4.50073 39.2826 4.50073C41.3101 4.50073 42.3223 5.67693 42.3223 7.42739V18.1828H39.9112V7.54933C39.9112 7.07042 39.6262 6.77221 39.2206 6.77221C38.8769 6.77221 38.593 7.01167 38.4711 7.34978L35.1476 15.9335C34.6199 17.4655 33.7298 18.4245 31.905 18.4245C29.8996 18.4245 28.8874 17.2483 28.8874 15.4756V7.54933C28.8874 7.07042 28.5848 6.77221 28.178 6.77221C27.8122 6.77221 27.5683 7.01167 27.4285 7.34978L23.3368 18.1851L23.3402 18.1883L23.3391 18.1895Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMercleLogoWhite);
export default __webpack_public_path__ + "static/media/mercle-logo-white.16df00a1c85b4a25abc9a60674bf8537.svg";
export { ForwardRef as ReactComponent };